module.exports = __webpack_public_path__ + "img/security_offices.886a1aea.jpg";